import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Spinner from "react-bootstrap/Spinner";
import { allFeatured, getFeatured } from '../reducers/catalog';
import Product from "./Product";
import PrintItemCard from "./PrintItemCard";
import { getSubsite } from '../reducers/auth';
import Container from 'react-bootstrap/Container';
import SubsiteService from "../services/subsite.service";
import { useNavigate } from "react-router-dom";
import { resolveRetailHomePath, usesFeaturedHome } from "../utils/retailHome";

const BACKEND_URL = process.env.REACT_APP_LOCALHOST_URL;

const Featured = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const featured = useSelector(allFeatured);
  const currentSubsite = useSelector(getSubsite);
  const [featuredContent, setFeaturedContent] = useState(<Spinner text="Loading..." />);

  const [content, setContent] = useState('');

  useEffect(() => {
    if (currentSubsite && !usesFeaturedHome(currentSubsite)) {
      resolveRetailHomePath(currentSubsite).then((path) => {
        if (path !== "/featured") navigate(path, { replace: true });
      });
    }
  }, [currentSubsite, navigate]);

  useEffect(() => {
    async function fetchData() {
      var content = await SubsiteService.getHomepageContent();
      console.log("CONTENT", content);
      setContent(content.homepage);
      //var shipping = await ShippingService.getShipping();
      //console.log("SHIPPING", shipping);
      dispatch(getFeatured());
    }
    fetchData();
  }, []);


  return (
    <Container>
      <div style={{ padding: 30 }}>
        {(!content || content == "" || content == "<p><br></p>") && <h3>Welcome to {currentSubsite?.subsiteName} Apparel Site</h3>}
        {content && <div dangerouslySetInnerHTML={{ __html: content }}></div>}

        <h3>Featured Items</h3>
        <div class="product-container">
          {featured && featured.map(featuredItem => (
            featuredItem.isPrintItem
              ? <PrintItemCard key={`printitem_${featuredItem.id}`} item={featuredItem} />
              : <Product key={`product_${featuredItem.id}`} product={featuredItem} featured />
          ))}
          {!featured && <Spinner text="Loading..." />}
        </div>
      </div>
    </Container>
  );
};
export default Featured;